import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as demoActions from './demoActions';

export type DemoAction = ActionType<typeof demoActions>;

export interface IDemoStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IDemoType };
	readonly queries: { [queryKey: string]: IDemoType[] };
}

export function demoReducer(
	state = baseInitialState as IDemoStateType,
	action: DemoAction,
) {
	const Reducer = new BaseReducer('demoReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
